import { State as MonerisVaultState } from '../reducers/moneris-vault-reducer';
import { Selector } from '@ngrx/store';
export const getIsActive: Selector<MonerisVaultState, boolean> = (state: MonerisVaultState) => state.isActive;
export const getMessage: Selector<MonerisVaultState, string | null> = (state: MonerisVaultState) => state.message;
export const getHasError: Selector<MonerisVaultState, boolean> = (state: MonerisVaultState) => state.hasError;
export const getHasSuccess: Selector<MonerisVaultState, boolean> = (state: MonerisVaultState) => state.hasSuccess;
export const getIsVisible: Selector<MonerisVaultState, boolean> = (state: MonerisVaultState) => state.isVisible;
export const getResult: Selector<MonerisVaultState, any | null> = (state: MonerisVaultState) => state.result;
